<template>
    <footer v-if="appParams && appParams.staticTranslations">
        <div class="itb-bar" v-lazy-container="{ selector: '.itb-lazy' }">
            <div class="container">
                <div
                    class="d-flex flex-column flex-md-row align-items-baseline"
                >
                    <div class="flex-grow-1">
                        <a href="/" id="itb-footer-logo">
                            <img
                                class="itb-lazy"
                                data-src="/images/logo.png"
                                :alt="
                                    appParams.staticTranslations[
                                        'general.4soft_logo_link'
                                    ]
                                "
                            />
                        </a>
                    </div>
                    <div>
                        <span class="font-weight-bold">{{
                            appParams.staticTranslations[
                                "general.certification"
                            ]
                        }}</span>
                        <img
                            class="itb-lazy"
                            data-src="/images/itc-logo.png"
                            :alt="
                                appParams.staticTranslations['general.itc_link']
                            "
                            id="itb-itc"
                        />
                    </div>
                    <div id="itb-insta" class="mt-3 mt-md-0">
                        <span class="font-weight-bold">{{
                            appParams.staticTranslations["general.instagram"]
                        }}</span>
                        <a
                            :href="appParams.general_instagram"
                            target="_blank"
                            style="margin-left: 22px"
                        >
                            <img
                                data-src="/images/icons/4soft_icon_instagram.svg"
                                :alt="
                                    appParams.staticTranslations[
                                        'general.instagram_link'
                                    ]
                                "
                                class="itb-icon itb-lazy"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="itb-content">
            <div class="container">
                <div class="d-flex flex-column flex-md-row align-items-start">
                    <div itemscope itemtype="http://schema.org/Organization">
                        <div class="font-weight-bold" itemprop="name">
                            {{ appParams.general_company_name }}
                        </div>
                        <div itemprop="streetAddress">
                            {{ appParams.general_company_street }}
                        </div>
                        <div itemprop="addressLocality">
                            {{ appParams.general_company_city }}
                        </div>
                         <div itemprop="addressCountry" v-if="appParams.general_company_country">
                            {{  appParams.general_company_country  }}
                        </div>
                        <div id="itb-phone">
                            {{ appParams.staticTranslations["general.phone"] }}
                            <a
                                :href="'tel:' + stripedPhone"
                                itemprop="telephone"
                                >{{ appParams.general_phone }}</a
                            >
                        </div>
                        <div>
                            {{ appParams.staticTranslations["general.email"] }}
                            <a
                                :href="
                                    'mailto:' +
                                    appParams.general_email +
                                    '?Subject=' +
                                    appParams.staticTranslations[
                                        'general.email_subject'
                                    ]
                                "
                                itemprop="email"
                                >{{ appParams.general_email }}</a
                            >
                        </div>
                    </div>
                    <div class="mt-3 mt-md-0">
                        <ul class="itb-list-unstyled" id="itb-links-1">
                            <li>
                                <router-link :to="{ name: 'home' }">{{
                                    appParams.staticTranslations[
                                        "title.our_offer"
                                    ]
                                }}</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'products2D' }">{{
                                    appParams.staticTranslations[
                                        "title.products_2d"
                                    ]
                                }}</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'products3D' }">{{
                                    appParams.staticTranslations[
                                        "title.products_3d"
                                    ]
                                }}</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'otherProducts' }">{{
                                    appParams.staticTranslations[
                                        "title.other_products"
                                    ]
                                }}</router-link>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <ul class="itb-list-unstyled" id="itb-links-2">
                            <li>
                                <router-link :to="{ name: 'ourService' }">{{
                                    appParams.staticTranslations[
                                        "title.our_service"
                                    ]
                                }}</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'graphics' }">{{
                                    appParams.staticTranslations[
                                        "title.graphics"
                                    ]
                                }}</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'contact' }">{{
                                    appParams.staticTranslations[
                                        "title.contacts"
                                    ]
                                }}</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'download' }">{{
                                    appParams.staticTranslations[
                                        "title.download"
                                    ]
                                }}</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="align-self-end ml-md-auto mt-3 md-mt-0">
                        © 2023 4soft by
                        <a
                            href="https://itband.eu/?utm_source=4soft.cz&amp;utm_medium=link-footer&amp;utm_campaign=author-link-clicked"
                            rel="designer"
                            target="_blank"
                            >it_BAND</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            messageDialog: true,
        };
    },

    computed: {
        ...mapGetters({ appParams: "getAppParams", params: "getPageParams" }),
        stripedPhone() {
            return this.appParams.general_phone
                ? String(this.appParams.general_phone).replace(/\s/g, "")
                : "";
        },
    },

    methods: {},
};
</script>
